import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { Router } from '@angular/router';
import { PayGatewayComponent } from '../pay-gateway/pay-gateway.component';

@Component({
  selector: 'app-tclc-fees-process',
  templateUrl: './tclc-fees-process.component.html',
  styleUrls: ['./tclc-fees-process.component.scss']
})
export class TclcFeesProcessComponent implements OnInit {
  FeeForm: FormGroup;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  AdModeList: any;
  filteredAdModeList: any;
  SRList: any;
  filteredSR: any;
  totalAmount = 0;
  lvl: 0;
  zeroError = false;
  inputTimeout: any;
  arrTest: any = [];
  tabldata: any;
  selectedoption: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  totalPayableAmount: number;
  totalPayAmount = 0;
  remainAmt = 0;
  StudentPersonalId;
  feeMode;
  tabldata2: any;
  ramt: number;
  Total = true;
  Message = false;
  due: number;
  RAmt
  submitButton = true;
  updateButton = false;
  feeApplyArray: FormArray;
  updateBtn = true;
  payHistoryBtn = false;
  disablePaid = true
  xyz: any;
  errMsg: any;
  payModeList: any;
  shouldShowErrorMessage: boolean = false;
  lastPaid: any;
  newPaid: any;
  filteredpayModeList: any;
  SnNo: any;
  filteredElements: any;
  FeeLevel: any;
  feeModeShow = true;
  ExamCurrency
  Certificate: any;
  TotalFee: any;
  CopiesFee: number;
  SoftCopyFee: number = 0;
  HardCopyFee: number = 0;
  PerCopyDeliveryFee: number = 0;
  totalHardCopyFee: number;
  tableData: any[] = [];
  PostalCharges: number;
  TranscriptFee: any;
  TranscriptData: any;
  VodData: any;
  isAttestation: boolean = false;
  isVerification: boolean = false;
  PayableHeadsCount: number = 0;
  SelectedSubjectIds: number[] = [];
  SelectedHeadIds: number[] = [];
  SelectedSubjectCount: number = 0;
  SelectedHeadCount: number = 0;

  constructor(private fb: FormBuilder,
    public umsService: UmsService, public dialogRef1: MatDialogRef<TclcFeesProcessComponent>,
    public dialog: MatDialog, private modalpopService: ModalpopService, public router: Router,
    private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public item1: any,
  ) { }
  FeeTable: any;
  tempCo = sessionStorage.getItem('TemplateCode');
  Transcript = false

  ngOnInit(): void {
    this.Transcript = false
    switch (this.data['CertType']) {
      case "TC":
        this.Certificate = 'Transfer Certificate'
        break
      case "LC":
        this.Certificate = 'Leaving Certificate'
        break;
      case "MC":
        this.Certificate = 'Migration Certificate'
        break;
      case "TS":
        this.Certificate = 'Transcript Certificate'
        break;
      case "ATTFE":
        this.Certificate = 'Attestation Certificate'
        break;
      case "VOD":
        this.Certificate = 'Verification of University Document'
        break;
      case "RET":
        this.Certificate = 'Retotaling of marks'
        break;
      default:

        break
    }
    this.payHistoryBtn = false;
    this.PayableHeadsCount = Number(this.data && this.data['PayableHeadsCount']) || 0;

    this.SelectedSubjectIds = (this.data && this.data['SelectedSubjectIds']) || [];
    this.SelectedHeadIds = (this.data && this.data['SelectedHeadIds']) || [];
    this.SelectedSubjectCount = Number(this.data && this.data['SelectedSubjectCount']) || 0;
    this.SelectedHeadCount = Number(this.data && this.data['SelectedHeadCount']) || 0;
    this.getFeeTempData(this.data['CertType'])
    this.updateBtn = true;
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    this.totalAmount = 0;
    this.totalPayAmount = 0;
    this.remainAmt = 0;
    this.Total = true;
    this.Message = false;
    this.ramt = 0;
    this.due = 0;
    this.lvl = 0;

    this.FeeForm = this.fb.group({
      TemplateName: new FormControl('', [Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      StudentType: new FormControl('', []),
      StudentStatus: new FormControl(''),
      SocialReservation: new FormControl(''),
      TotalPaidAmount: new FormControl('', Validators.required),
      PayMode: new FormControl(''),
      feeHeadArray: new FormArray([]),

    });
    this.fetchPayMode();
  }

  getFeeTempData(CertType) {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = this.data['CertType'];
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.ExamCurrency = res.data[0].Currency
        this.isAttestation = (this.data['CertType'] === 'ATTFE');
        this.isVerification = (this.data['CertType'] === 'VOD');
        this.getSecretData()
      } else {
        this.getSecretData()
        this.FeeLevel = null
      }
    });
  }

  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId") != null ? sessionStorage.getItem("StudentPersonalId") : sessionStorage.getItem("StudentRGID");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.searchExams(res.data[0]['RgId'])
        this.GetEcId(res.data[0]['RgId'])
      }
      else {
      }
    })
  }

  GetEcId(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.getSecretData()
          // this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.getSecretData()
          // this.ExmFormSub(res.data[0]['EcId'], RgId)
        }

      }
    });
  }

  searchExams(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }

      }
    });
  }

  ExmFormSub(EcId, RgId) {
    this.filteredElements = []
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.filteredElements = res.data.filter(element => {
          if (element.EsType == 'S' && (element.App == 'Y' || element.App == ' ')) {
            return element
          }
        });
        this.getSecretData()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }



  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      this.prepopulation(res.projectPharam['SnNo']);
    })

  }
  prepopulation(SnNo) {

    this.Total = true;
    this.Message = false;
    this.spinner.show();
    const payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo

    let ascAlreadyAttached = false;
    if (this.data.CertType === 'ASC' || this.data.CertType === 'RET') {
      ascAlreadyAttached = !!(this.data.AllSubjectData || []).some(item =>
        item.StuSubId == this.data.StuSubId &&
        item.PaymentResponseID && item.PaymentResponseID != '' &&
        item.CertType === this.data.CertType
      );
    }

    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      let data = res.data[0];
      this.spinner.hide();

      const useHistoryBranch = res.status && !((this.data.CertType === 'ASC' || this.data.CertType === 'RET') && !ascAlreadyAttached);

      if (useHistoryBranch) {
        //alert("Please select the subject for which you want to pay the fee.");

        this.updateButton = true;

        this.submitButton = false;
        this.payHistoryBtn = true;
        this.tabldata2 = res.data;
        this.FeeForm = this.fb.group({
          TotalPaidAmount: new FormControl(''),
          PayMode: new FormControl(data.PayMode),
          feeHeadArray: new FormArray([]),
        });
        this.tabldata2 = res.data;
        this.lastPaid = data.TotalPaidAmount

        this.tabldata2.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              HeadName: new FormControl(element.Head),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.FeeDue),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeeAmt: new FormControl(element.FeeAmount, [Validators.required,]),
            })
          );
          this.FeeForm.controls['TotalPaidAmount'].setValue('');
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
          this.remainAmt = this.totalAmount - this.lastPaid
          this.totalPayAmount = this.totalAmount - this.remainAmt;
          this.ramt = this.remainAmt;
          if (this.remainAmt == 0) {
            this.payHistoryBtn = true
          }
          else {
            this.payHistoryBtn = false
          }
          if (this.remainAmt == 0) {
            this.updateBtn = true;
            this.Total = false;
            this.Message = true;
            this.payHistoryBtn = true
          } else {
            this.updateBtn = false;
            this.Total = true;
            this.Message = false;
            this.payHistoryBtn = false
          }
        });
        if (this.data.CertType === 'ASC' || this.data.CertType === 'RET') {
          this.FeeTable = res.data;
          this.Transcript = false;
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.clear();
          this.totalAmount = 0;
          this.FeeTable.forEach((element, index) => {

            if (index === 0) {

              const feeAmount = Number(element.FeeAmount) || 0;

              creds.push(
                this.fb.group({
                  FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                  HeadName: new FormControl(element.Head),
                  FeePaid: new FormControl(0),
                  FeeDue: new FormControl(feeAmount),
                  FeeDueDummy: new FormControl(feeAmount),
                  FeeAmt: new FormControl(feeAmount, [Validators.required]),
                })
              );

              this.totalAmount = feeAmount;
            }

          });
          this.remainAmt = this.totalAmount;
          this.totalPayAmount = 0;
          this.ramt = this.remainAmt;
          this.TotalFee = this.totalAmount;

        }
        else if (this.data.CertType === 'LANG') {
          this.FeeTable = res.data;
          this.Transcript = false;
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.clear();

          this.totalAmount = 0;

          this.FeeTable.forEach((element, index) => {

            if (index === 0) {

              const feeAmount = Number(element.FeeAmount) || 0;

              creds.push(
                this.fb.group({
                  FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                  HeadName: new FormControl(element.Head),
                  FeePaid: new FormControl(0),
                  FeeDue: new FormControl(feeAmount),
                  FeeDueDummy: new FormControl(feeAmount),
                  FeeAmt: new FormControl(feeAmount, [Validators.required]),
                })
              );

              this.totalAmount = feeAmount;
            }

          });
          this.remainAmt = this.totalAmount;
          this.totalPayAmount = 0;
          this.ramt = this.remainAmt;
          this.TotalFee = this.totalAmount;

        }
      } else {
        this.spinner.show();
        const payload = {};
        payload['TemplateCode'] = this.tempCo;
        payload['FeeType'] = ''
        this.updateButton = false;
        this.submitButton = true;
        this.totalAmount = 0
        this.umsService.getFeeTemplet(payload).subscribe((res) => {
          this.spinner.hide()
          let data = res.data[0];
          if (res.status) {
            this.tabldata = res.data;
            this.FeeForm = this.fb.group({
              TotalPaidAmount: new FormControl(''),
              PayMode: new FormControl(data.PayMode),
              feeHeadArray: new FormArray([]),
            });
            this.FeeTable = res.data;

            if (this.data['CertType'] === 'TS') {
              this.CalculateFee();
            }
            else if (['ATTFE'].includes(this.data['CertType'])) {
              this.CalculateAttestationFee();
            }
            else if (['VOD'].includes(this.data['CertType'])) {
              this.CalculateVerificationFee();
            }
            else {
              if (this.data['CertType'] === 'ASC' || this.data['CertType'] === 'RET') {

                this.Transcript = false;

                const creds = this.FeeForm.controls.feeHeadArray as FormArray;

                this.FeeTable.forEach((element, i) => {
                  for (let j = 0; j < this.PayableHeadsCount; j++) {
                    creds.push(
                      this.fb.group({
                        FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                        HeadName: new FormControl(element.Head),
                        FeePaid: new FormControl(0),
                        FeeDue: new FormControl(element.FeeAmount),
                        FeeDueDummy: new FormControl(element.FeeAmount),
                        FeeAmt: new FormControl(element.FeeAmount, [Validators.required]),
                      })
                    );
                  }

                  // multiply the amount by PayableHeadsCount for this fee head
                  this.totalAmount =
                    this.totalAmount + parseInt(element.FeeAmount) * this.PayableHeadsCount;
                });

                this.remainAmt = this.totalAmount;
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
                this.TotalFee = this.totalAmount;
              }
              else {
                this.Transcript = false;
                this.FeeTable.forEach((element, i) => {
                  const creds = this.FeeForm.controls.feeHeadArray as FormArray;
                  creds.push(
                    this.fb.group({
                      FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                      HeadName: new FormControl(element.Head),
                      FeePaid: new FormControl(0),
                      FeeDue: new FormControl(element.FeeAmount),
                      FeeDueDummy: new FormControl(element.FeeAmount),
                      FeeAmt: new FormControl(element.FeeAmount, [Validators.required]),
                    })
                  );
                  this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
                  this.remainAmt = this.totalAmount;
                  this.totalPayAmount = this.totalAmount - this.remainAmt;
                  this.ramt = this.remainAmt;
                  this.TotalFee = this.totalAmount;
                });
              }
              // For all other certificate types (TC, LC, MC)

            }
          } else {
            // this.umsService.openSnackbar(res.message);
          }
        });
      }
      if (this.data.CertType === 'ASC') {
        const alreadyAttached = this.data.AllSubjectData.some(item =>
          item.StuSubId == this.data.StuSubId &&
          item.PaymentResponseID && item.PaymentResponseID != '' &&
          item.CertType === 'ASC'
        );

        if (!alreadyAttached) {
          this.submitButton = true;
          this.payHistoryBtn = false;
        }
      }
      if (this.data.CertType === 'RET') {
        const alreadyAttached = this.data.AllSubjectData.some(item =>
          item.StuSubId == this.data.StuSubId &&
          item.PaymentResponseID && item.PaymentResponseID != '' &&
          item.CertType === 'RET'
        );

        if (!alreadyAttached) {
          this.submitButton = true;
          this.payHistoryBtn = false;
        }
      }
      if (this.data.CertType === 'LANG') {
        const alreadyAttached = this.data.AllSubjectData.some(item =>
          item.StuSubId == this.data.StuSubId &&
          item.PaymentResponseID && item.PaymentResponseID != '' &&
          item.CertType === 'LANG'
        );

        if (!alreadyAttached) {
          this.submitButton = true;
          this.payHistoryBtn = false;
        }
      }
    });
  }

  CalculateVerificationFee() {
    this.spinner.show();
    let payload: any = {};
    payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');

    console.log('Calculating VOD Fee for StuId:', payload['StuId']);

    this.umsService.SearchTranscript(payload).subscribe(
      (res) => {
        console.log('SearchTranscript Response:', res);

        if (res.status && res.data && res.data.length > 0) {
          // Filter for VOD type
          const vodData = res.data.filter(d => d.CertType === 'VOD');
          console.log('Filtered VOD Data:', vodData);

          if (vodData.length > 0) {
            this.VodData = vodData[0];
            this.Transcript = true;
            this.TranscriptData = null; // Clear TranscriptData for VOD

            // VOD Fee Structure
            const BaseFee = 3050;  // Base fee for VOD
            const PerCopyFee = 800; // Fee per additional document
            const SoftCopyFeeAmount = 800; // Soft copy delivery fee
            const HardCopyBaseFee = 2570; // Hard copy base fee
            const PerCopyDelivery = 800; // Per copy delivery charges

            const CertCopies = Number(this.VodData.StuCertCopies || 0);
            const Delivery = this.VodData.DeliveryOpt || '';

            // VOD: when DeliverAt is "IN" (within India) do not apply postal charges / By Air Mail Charges
            const isIndiaStudent = this.isStudentWithinIndia();

            console.log('VOD Data Details:', {
              CertCopies,
              Delivery,
              StuCertCopies: this.VodData.StuCertCopies,
              DeliveryOpt: this.VodData.DeliveryOpt,
              DeliverAt: this.VodData.DeliverAt
            });

            this.TotalFee = 0;
            this.CopiesFee = 0;
            this.TranscriptFee = 0;
            this.SoftCopyFee = 0;
            this.HardCopyFee = 0;
            this.PerCopyDeliveryFee = 0;
            this.PostalCharges = 0;

            // Calculate Copies Fee
            this.CopiesFee = PerCopyFee * CertCopies;
            this.TranscriptFee = BaseFee + this.CopiesFee;

            if (Delivery === 'Soft') {
              this.SoftCopyFee = SoftCopyFeeAmount;
              this.PostalCharges = this.SoftCopyFee;
            }
            else if (Delivery === 'Hard') {
              // VOD: when DeliverAt is "IN" do not apply By Air Mail Charges (Hard Copy Base Fee) or per-copy delivery
              this.HardCopyFee = isIndiaStudent ? 0 : HardCopyBaseFee;
              this.PerCopyDeliveryFee = isIndiaStudent ? 0 : (PerCopyDelivery * CertCopies);
              this.PostalCharges = this.HardCopyFee + this.PerCopyDeliveryFee;
            }
            else if (Delivery === 'Both') {
              this.SoftCopyFee = SoftCopyFeeAmount;
              // VOD: when DeliverAt is "IN" do not apply By Air Mail Charges (Hard Copy Base Fee) or per-copy delivery
              this.HardCopyFee = isIndiaStudent ? 0 : HardCopyBaseFee;
              this.PerCopyDeliveryFee = isIndiaStudent ? 0 : (PerCopyDelivery * CertCopies);
              this.PostalCharges = this.SoftCopyFee + this.HardCopyFee + this.PerCopyDeliveryFee;
            }

            this.TotalFee = this.TranscriptFee + this.PostalCharges;

            const creds = this.FeeForm.controls.feeHeadArray as FormArray;

            // Clear existing rows
            while (creds.length > 0) {
              creds.removeAt(0);
            }

            // Build table data - only include items with amount > 0
            this.tableData = [];

            // Always add Base Amount (Verification Fee)
            this.tableData.push({
              head: 'Verification Fee',
              headName: 'Verification Fee',
              feeAmount: BaseFee
            });

            // Add Copies Fee if > 0
            if (this.CopiesFee > 0) {
              this.tableData.push({
                head: `Fee For Verification (${CertCopies} Set${CertCopies > 1 ? 's' : ''})`,
                headName: 'Copies Fee',
                feeAmount: this.CopiesFee
              });
            }

            // Add Postal Charges if > 0
            if (this.PostalCharges > 0) {
              this.tableData.push({
                head: 'Postal Charges',
                headName: 'Total Delivery Charges',
                feeAmount: this.PostalCharges
              });
            }

            // Add Hard Copy Base Fee if > 0 (skipped when DeliverAt is "IN")
            if (this.HardCopyFee > 0) {
              this.tableData.push({
                head: 'By Air Mail Charges',
                headName: 'By Air Mail Charges',
                feeAmount: this.HardCopyFee
              });
            }

            // Add Per Copy Delivery if > 0
            if (this.PerCopyDeliveryFee > 0) {
              this.tableData.push({
                head: 'Extra Hard Copy Delivery Charges',
                headName: 'Per Copy Delivery',
                feeAmount: this.PerCopyDeliveryFee
              });
            }

            // Add Soft Copy if > 0
            if (this.SoftCopyFee > 0) {
              this.tableData.push({
                head: 'By Email Charges',
                headName: 'By Email Charges',
                feeAmount: this.SoftCopyFee
              });
            }

            console.log('Final Table Data:', this.tableData);
            console.log('Total Fee:', this.TotalFee);

            // Add fee rows
            this.tableData.forEach((element) => {
              // Only add rows with amount > 0
              if (element.feeAmount > 0) {
                creds.push(
                  this.fb.group({
                    FeeHead: new FormControl(element.head, [Validators.required]),
                    HeadName: new FormControl(element.headName),
                    FeePaid: new FormControl(0),
                    FeeDue: new FormControl(element.feeAmount),
                    FeeDueDummy: new FormControl(element.feeAmount),
                    FeeAmt: new FormControl(element.feeAmount, [Validators.required]),
                  })
                );
              }
            });

            this.updateBtn = false;

            this.spinner.hide();
          } else {
            console.log('No VOD data found, showing base fee only');
            this.handleNoVodData();
          }
        } else {
          console.log('No data returned from API, showing base fee only');
          this.handleNoVodData();
        }
      },
      (error) => {
        console.error('Error fetching VOD data:', error);
        this.spinner.hide();
        this.handleNoVodData();
      }
    );
  }

  // VOD: when DeliverAt is "IN" (within India) do not apply postal charges / By Air Mail Charges
  isStudentWithinIndia(): boolean {
    if (!this.VodData) {
      return true;
    }

    const deliverAt = (this.VodData?.DeliverAt || '').toString().trim().toUpperCase();
    if (deliverAt === 'IN' || deliverAt === 'INDIA') {
      return true;
    }
    if (deliverAt === 'OFI' || deliverAt === 'OUT' || deliverAt === 'OUTSIDE') {
      return false;
    }

    const country = (this.VodData?.Country || this.VodData?.CountryName ||
      this.VodData?.StuCountry || this.VodData?.StuCountryName || '')
      .toString().trim().toLowerCase();

    // If the country/delivery location is not available, consider the student as within India (no postal charges)
    if (!country) {
      return true;
    }

    return country === 'india' || country === 'ind' || country === 'in' || country === 'bharat';
  }

  handleNoVodData() {
    console.log('Handling no VOD data - showing base fee only');
    const BaseFee = 3050;
    this.TotalFee = BaseFee;
    this.TranscriptFee = BaseFee;
    this.CopiesFee = 0;
    this.PostalCharges = 0;
    this.SoftCopyFee = 0;
    this.HardCopyFee = 0;
    this.PerCopyDeliveryFee = 0;
    this.Transcript = true;
    this.VodData = null;
    this.TranscriptData = null;

    const creds = this.FeeForm.controls.feeHeadArray as FormArray;

    while (creds.length > 0) {
      creds.removeAt(0);
    }

    this.tableData = [
      {
        head: 'Verification Fee',
        headName: 'Verification Fee',
        feeAmount: BaseFee
      }
    ];

    this.tableData.forEach((element) => {
      creds.push(
        this.fb.group({
          FeeHead: new FormControl(element.head, [Validators.required]),
          HeadName: new FormControl(element.headName),
          FeePaid: new FormControl(0),
          FeeDue: new FormControl(element.feeAmount),
          FeeDueDummy: new FormControl(element.feeAmount),
          FeeAmt: new FormControl(element.feeAmount, [Validators.required]),
        })
      );
    });

    console.log('Base fee table data:', this.tableData);
    console.log('Total Fee (Base only):', this.TotalFee);

    this.updateBtn = false;

    this.spinner.hide();
  }


  handleNoAttestationData() {
    const BaseAmount = 3050;
    this.TotalFee = BaseAmount;
    this.TranscriptFee = BaseAmount;
    this.CopiesFee = 0;
    this.PostalCharges = 0;
    this.SoftCopyFee = 0;
    this.HardCopyFee = 0;
    this.PerCopyDeliveryFee = 0;
    this.Transcript = true;
    this.TranscriptData = null;
    this.VodData = null;

    const creds = this.FeeForm.controls.feeHeadArray as FormArray;

    while (creds.length > 0) {
      creds.removeAt(0);
    }

    this.tableData = [
      {
        head: 'Base Amount',
        headName: 'Base Attestation Fee',
        feeAmount: BaseAmount
      }
    ];

    this.tableData.forEach((element) => {
      creds.push(
        this.fb.group({
          FeeHead: new FormControl(element.head, [Validators.required]),
          HeadName: new FormControl(element.headName),
          FeePaid: new FormControl(0),
          FeeDue: new FormControl(element.feeAmount),
          FeeDueDummy: new FormControl(element.feeAmount),
          FeeAmt: new FormControl(element.feeAmount, [Validators.required]),
        })
      );
    });

    this.spinner.hide();
  }

  CalculateFee() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if (res.status) {
        this.TranscriptData = res.data[0]
        this.Transcript = true
        this.VodData = null; // Clear VodData for Transcript
        let BaseAmount = 2190;
        let CertCopies = res.data[0].StuCertCopies
        let Delivery = res.data[0].DeliveryOpt;
        let DeliveryAt = res.data[0].DeliverAt;
        let PerCopyFee = 2190;
        let SoftCopy = 800;
        let HardCopy = 0;
        let PerCopyDelivery = 2570;
        this.TotalFee = 0;

        if (CertCopies == 7) {
          this.TotalFee = 15300;
          this.CopiesFee = PerCopyFee * CertCopies - 30;
          this.TranscriptFee = this.TotalFee + this.CopiesFee;
        } else {
          if (CertCopies > 0) {
            this.TotalFee += PerCopyFee * CertCopies;
            this.CopiesFee = PerCopyFee * CertCopies;
            this.TranscriptFee = BaseAmount + this.CopiesFee;
          }
          else {
            this.TranscriptFee = BaseAmount;
            this.CopiesFee = 0
            this.TranscriptFee = BaseAmount
          }
        }

        if (Delivery === 'Soft') {
          this.TotalFee += SoftCopy;
          this.SoftCopyFee = SoftCopy;
          this.PostalCharges = this.SoftCopyFee;
        }
        else if (Delivery === 'Hard' && DeliveryAt == 'OFI') {
          this.HardCopyFee = HardCopy;
          this.PerCopyDeliveryFee = PerCopyDelivery;
          this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
          this.PostalCharges = this.totalHardCopyFee
          this.TotalFee += this.PerCopyDeliveryFee;
        }
        else if (Delivery === 'Both' && DeliveryAt == 'OFI') {
          this.TotalFee += SoftCopy + HardCopy + PerCopyDelivery;
          this.SoftCopyFee = SoftCopy
          this.HardCopyFee = HardCopy;
          this.PerCopyDeliveryFee = PerCopyDelivery;
          this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
          this.PostalCharges = this.SoftCopyFee + this.totalHardCopyFee;
        }
        else if (Delivery === 'Hard' && DeliveryAt == 'IN') {
          this.TotalFee += HardCopy + 0;
          this.HardCopyFee = HardCopy;
          this.PerCopyDeliveryFee = 0;
          this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
          this.PostalCharges = 0
        }
        else if (Delivery === 'Both' && DeliveryAt == 'IN') {
          this.TotalFee += SoftCopy + 0 + 0;
          this.SoftCopyFee = SoftCopy
          this.HardCopyFee = HardCopy;
          this.PerCopyDeliveryFee = 0;
          this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
          this.PostalCharges = this.SoftCopyFee + 0;
        }
        this.tableData = [
          { head: 'Transcript Fee', headName: 'Total Transcript Fee', feeAmount: this.CopiesFee },
          { head: `Fee For Transcript (${CertCopies} Set)`, headName: 'Copies', feeAmount: this.CopiesFee },
          { head: 'Postal Charges', headName: 'Total Delivery Charges', feeAmount: this.PostalCharges },
          { head: `For Delivery Charges`, headName: 'Copies', feeAmount: this.PerCopyDeliveryFee },
          { head: 'Soft Copy', headName: 'Soft Copy Amount', feeAmount: this.SoftCopyFee },
        ];
        this.tableData.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.head, [Validators.required]),
              HeadName: new FormControl(element.headName),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.feeAmount),
              FeeDueDummy: new FormControl(element.feeAmount),
              FeeAmt: new FormControl(element.feeAmount, [Validators.required,]),
            })
          );
        });
        this.spinner.hide()
      }
      else {
        this.spinner.hide()
      }
    })
  }

  errorcheckP(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.pattern
  }

  errorcheckR(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.required

  }

  getfeeHeadArrayControls() {
    return (this.FeeForm.get('feeHeadArray') as FormArray).controls;
  }

  close() {
    this.dialogRef1.close();
  }

  submitFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsTouched();
    }
    else {
      this.submit()
    }
  }

  submit() {
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.tempCo), //add neww
            StuId: new FormControl(this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID')),
            FeeType: new FormControl(this.data['CertType']),
            FeeHead: new FormControl(element.FeeHead),
            FeeStatus: new FormControl('Y'),
            FeeAmt: new FormControl(element.FeeAmt),
            FeePaid: new FormControl(element.FeePaid),
            FeeDue: new FormControl(element.FeeAmt),
            FeeDueDummy: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.feeMode),
            TotalPaidAmount: new FormControl(this.TotalFee),
            PayMode: new FormControl(this.submitpayload.PayMode),
            SnNo: new FormControl(this.SnNo),
            CreatedBy: new FormControl(''),
            TotalFeeAmount: new FormControl(this.TotalFee)
          })
        )
        this.umsService.addFeeTemplet(arr1[0].value).subscribe(res => {

          // this.spinner.hide();
          // const paymentDetails = {
          //   "amount": arr1[0].value.TotalPaidAmount,
          //   "StuId": this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID'),
          //   "FeeTemplateCode": this.tempCo,
          //   "FeeType": this.data['CertType'],
          //   "SnNo": this.SnNo.toString(),
          //   "firstname": arr1[0].value.FeeHead,
          //   "email": "jeeevishnu@gmail.com",
          //   "phone": "8296270993"
          // }
          // this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
          //   window.location.href = response.redirectUrl;

          //   // this.spinner.hide();
          // });
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // const paymentDetails = {
            //     "amount": arr1[0].value.TotalPaidAmount,
            //     "StuId" : this.StudentPersonalId,
            //     "FeeTemplateCode":this.tempCo,
            //     "FeeType": 'EF',
            //     "SnNo":this.SnNo,
            //     "firstname": arr1[0].value.FeeHead,
            //     "email": "jeeevishnu@gmail.com",
            //     "phone": "8296270993"
            //     }
            // this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
            //   window.location.href = response.redirectUrl;

            //   //  window.open(response.redirectUrl, '_blank');
            // });

          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        // this.saveApplicationDetails();
        // this.updateTC()
        this.openGatewayPopUp(this.FeeForm.value)
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'

        // this.dialogRef = this.modalpopService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.dialogRef1.close();
        // });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalpopService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
    });

  }

  updateTC() {
    let payload = {}
    payload['StuFaculty'] = this.data['StuFaculty'],
      payload['StuCourse'] = this.data['StuCourse'],
      payload['StuCollege'] = this.data['StuCollege'],
      payload['StuExam'] = this.data['StuExam'],
      payload['StuBranch'] = this.data['StuBranch'],
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = this.data['CertType'],
      payload['DestClg'] = this.data['DestClg'],
      payload['Reason'] = this.data['Reason'],
      payload['FeeStatus'] = 'Y';
    payload['CertStatus'] = 'Fees Paid';
    payload['StuId'] = this.data['StuId'],
      payload['TclcId'] = this.data['TclcId'],
      payload['Comment'] = '',
      payload['CertScr'] = '',
      payload['StatusBy'] = sessionStorage.getItem('loginId'),
      this.umsService.UpdateTclc(payload).subscribe((res) => {
        if (res.status) {

          this.redirect('TC-LC-MC')
        }
      })
  }


  saveApplicationDetails() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    // this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    payload['SessionId'] = sessionStorage.getItem('session');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['ApplicationName'] = 'Exam Fees'
    payload['ApplicationSubDate'] = formattedDate;
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
      } else {
        // this.spinner.hide()
      }
    })
  }

  amountCheck(index) {
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(index).get('FeeDue').value;
    this.FeeTable.forEach((element, i) => {
      if (element.FeeAmount < amountValue) {
        let data = {}
        data['message'] = "Payable Amount Should be Less than Or Equal to Due Amount"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalpopService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
    })
  }

  getAmount(event: any, i) {

  }

  onInputChange(val) {
    const tempData = val.target.value;
    this.updateBtn = false;
    // if (tempData.charAt(0) === '0') {
    //   this.zeroError = true;
    // }
    // else if (tempData.charAt(0) !== '0') {
    //   this.zeroError = false;
    // }
    if (tempData == '') {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    if (this.remainAmt == 0 && this.submitButton == true && this.lastPaid == undefined) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.totalAmount - tempData;
    }

    if (this.ramt < tempData || tempData > this.totalAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    else if (tempData == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.newPaid = 0;
    }
    else {
      if (this.lastPaid == undefined && this.submitButton == true) {
        this.shouldShowErrorMessage = false;
        this.remainAmt = this.totalAmount - tempData;
        if (this.remainAmt == 0) {
          this.updateBtn = false
        } else {
          this.updateBtn = true
        }
      }

      this.shouldShowErrorMessage = false;
      this.remainAmt = this.ramt - tempData;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData);
      if (this.remainAmt == 0) {
        this.updateBtn = false
      } else {
        this.updateBtn = true
      }
    }
  }


  dueAmt(event, i) {
    let arrayData = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i);
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeePaid').value;
    amountValue = parseInt(amountValue);
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    if (tempData[i]['FeePaid'] == '') {
      this.due = tempData[i]['FeeDueDummy'];
    }
    else {
      this.due = parseInt(tempData[i]['FeeDueDummy']) - parseInt(tempData[i]['FeePaid']);
    }
    this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
    this.feeApplyArray.at(i).get('FeeDue').setValue(this.due);
  }

  newFun(event, i) {
    let FeeDue1 = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeeDue').value;
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    let sumFeeDue = 0;
    tempData.forEach(element => {
      sumFeeDue += element.FeeDue;
    })
    this.remainAmt = sumFeeDue;
    this.totalPayAmount = this.totalAmount - this.remainAmt;
  }

  updateFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsTouched();
    }
    else {
      this.update()
    }
  }

  update() {
    this.zeroError = false;
    this.spinner.show();
    this.FeeForm.controls['TotalPaidAmount'].setValue(this.newPaid);
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.tempCo), //add neww
            StuId: new FormControl(this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID')),
            FeeType: new FormControl('TC'),
            FeeHead: new FormControl(element.FeeHead),
            FeeStatus: new FormControl('Y'),
            FeeAmt: new FormControl(element.FeeAmt),
            FeePaid: new FormControl(element.FeePaid),
            FeeDue: new FormControl(element.FeeAmt),
            FeeDueDummy: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.feeMode),
            TotalPaidAmount: new FormControl(this.totalAmount),
            PayMode: new FormControl(this.submitpayload.PayMode),
            SnNo: new FormControl(this.SnNo),
            CreatedBy: new FormControl(''),
            TotalFeeAmount: new FormControl(this.totalAmount)
          })
        )
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(res => {

          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          // if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            const paymentDetails = {
              "amount": arr1[0].value.TotalPaidAmount,
              "StuId": this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID'),
              "FeeTemplateCode": this.tempCo,
              "FeeType": 'EF',
              "SnNo": this.SnNo,
              "firstname": arr1[0].value.FeeHead,
              "email": "jeeevishnu@gmail.com",
              "phone": "8296270993"
            }
            this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
              window.open(response.redirectUrl, '_blank');
            });
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Update Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalpopService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef1.close();
        });
      } else {
        this.zeroError = true
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalpopService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
    });

  }


  openHistoryPopup() {
    const dialogRef4 = this.dialog.open(PaymentHistoryComponent,
      {
        disableClose: true,
        width: "900px",
        height: "auto",
      });
    dialogRef4.afterClosed().subscribe((result) => {

    });
  }

  onInputChange2(val) {
    const tempData = val.target.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
      this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);

    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }

  isGreaterThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount > this.totalAmount;
  }

  isSmallerThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount < this.totalAmount;
  }


  getAmount2() {
    // this.remainAmt = 0;
    const tempData = this.FeeForm.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
      // this.remainAmt =  this.remainAmt - tempData.TotalPaidAmount;
      // this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
      this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);

    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }


  fetchPayMode() {
    const payload = {};
    payload['CdType'] = 'PM';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.payModeList = res.data;
        this.filteredpayModeList = this.payModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }


  // CalculateFee() {
  //   this.spinner.show()
  //   let payload = {};
  //   payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
  //   this.umsService.SearchTranscript(payload).subscribe((res) => {
  //     if (res.status) {
  //       this.TranscriptData = res.data[0]
  //       this.Transcript = true
  //       let BaseAmount = 2190;  //14300 old
  //       let CertCopies = res.data[0].StuCertCopies
  //       let Delivery = res.data[0].DeliveryOpt;
  //       let DeliveryAt = res.data[0].DeliverAt;
  //       let PerCopyFee = 2190; //1690 old
  //       let SoftCopy = 800; //750 old
  //       let HardCopy = 0; //2400 old
  //       let PerCopyDelivery = 2570; //750 old
  //       this.TotalFee = 0;

  //       if (CertCopies == 7) {
  //         this.TotalFee = 15300;
  //         this.CopiesFee = PerCopyFee * CertCopies - 30;
  //         // substracting 30 rs bcoz MUHS circular publish and mistaken by admin set the fee 15300
  //         this.TranscriptFee = this.TotalFee + this.CopiesFee;
  //       } else {
  //         if (CertCopies > 0) {
  //           this.TotalFee += PerCopyFee * CertCopies;
  //           this.CopiesFee = PerCopyFee * CertCopies;
  //           this.TranscriptFee = BaseAmount + this.CopiesFee;
  //         }
  //         else {
  //           this.TranscriptFee = BaseAmount;
  //           this.CopiesFee = 0
  //           this.TranscriptFee = BaseAmount
  //         }
  //       }


  //       // Add delivery fees based on the selected option
  //       if (Delivery === 'Soft') {
  //         this.TotalFee += SoftCopy;
  //         this.SoftCopyFee = SoftCopy;
  //         this.PostalCharges = this.SoftCopyFee;
  //       }
  //       else if (Delivery === 'Hard' && DeliveryAt == 'OFI') {
  //         this.HardCopyFee = HardCopy; //0
  //         this.PerCopyDeliveryFee = PerCopyDelivery; //2570
  //         this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
  //         this.PostalCharges = this.totalHardCopyFee
  //         this.TotalFee += this.PerCopyDeliveryFee;
  //       }
  //       else if (Delivery === 'Both' && DeliveryAt == 'OFI') {
  //         this.TotalFee += SoftCopy + HardCopy + PerCopyDelivery;
  //         this.SoftCopyFee = SoftCopy
  //         this.HardCopyFee = HardCopy;
  //         this.PerCopyDeliveryFee = PerCopyDelivery;
  //         this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
  //         this.PostalCharges = this.SoftCopyFee + this.totalHardCopyFee;
  //       }
  //       else if (Delivery === 'Hard' && DeliveryAt == 'IN') {
  //         this.TotalFee += HardCopy + 0;
  //         this.HardCopyFee = HardCopy;
  //         this.PerCopyDeliveryFee = 0;
  //         this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
  //         this.PostalCharges = 0
  //       }
  //       else if (Delivery === 'Both' && DeliveryAt == 'IN') {
  //         this.TotalFee += SoftCopy + 0 + 0;
  //         this.SoftCopyFee = SoftCopy
  //         this.HardCopyFee = HardCopy;
  //         this.PerCopyDeliveryFee = 0;//in india delivery
  //         this.totalHardCopyFee = this.HardCopyFee + this.PerCopyDeliveryFee;
  //         this.PostalCharges = this.SoftCopyFee + 0;
  //       }
  //       this.tableData = [
  //         { head: 'Transcript Fee', headName: 'Total Transcript Fee', feeAmount: this.CopiesFee },
  //         // { head: 'Base Amount', headName: 'Base Amount', feeAmount: BaseAmount },
  //         { head: `Fee For Transcript (${CertCopies} Set)`, headName: 'Copies', feeAmount: this.CopiesFee },
  //         { head: 'Postal Charges', headName: 'Total Delivery Charges', feeAmount: this.PostalCharges },
  //         // { head: 'Hard Copy', headName: 'Hard Copy Amount', feeAmount: this.HardCopyFee },
  //         // { head: `Per Additional Set For Delivery (${CertCopies} Set)`, headName: 'Copies', feeAmount: this.PerCopyDeliveryFee },
  //         { head: `For Delivery Charges`, headName: 'Copies', feeAmount: this.PerCopyDeliveryFee },
  //         { head: 'Soft Copy', headName: 'Soft Copy Amount', feeAmount: this.SoftCopyFee },
  //       ];
  //       this.tableData.forEach((element, i) => {
  //         const creds = this.FeeForm.controls.feeHeadArray as FormArray;
  //         creds.push(
  //           this.fb.group({
  //             FeeHead: new FormControl(element.head, [Validators.required]),
  //             HeadName: new FormControl(element.headName),
  //             FeePaid: new FormControl(0),
  //             FeeDue: new FormControl(element.feeAmount),
  //             FeeDueDummy: new FormControl(element.feeAmount),
  //             FeeAmt: new FormControl(element.feeAmount, [Validators.required,]),
  //           })
  //         );
  //       });
  //       this.spinner.hide()
  //     }
  //     else {
  //       this.spinner.hide()
  //     }
  //   })
  // }
  // CalculateAttestationFee() {
  //     this.spinner.show();
  //     let payload = {};
  //     payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
  //     this.umsService.SearchTranscript(payload).subscribe((res) => {
  //         if (res.status) {
  //             this.TranscriptData = res.data[0];
  //             this.Transcript = true;
  //             const BaseAmount = 3050;        // for 7 copies
  //             const PerCopyFee = 800;         // each additional set beyond 7
  //             const SoftCopy = 800;           // delivery: soft copy
  //             const HardCopy = 0;             // delivery: hard copy (only delivery location matters)
  //             const PerCopyDelivery = 2570;   // delivery: per additional set for out-of-India

  //             let CertCopies = Number(res.data[0].StuCertCopies) || 0;
  //             let Delivery = res.data[0].DeliveryOpt;
  //             let DeliveryAt = res.data[0].DeliverAt;

  //             let CopiesFee = 0;
  //             let TotalFee = 0;
  //             if (CertCopies >= 7) {
  //                 const extra = CertCopies - 7;
  //                 CopiesFee = extra * PerCopyFee;
  //                 TotalFee = BaseAmount + CopiesFee;
  //             } else {
  //                 CopiesFee = 0;
  //                 TotalFee = BaseAmount;
  //             }
  //             let PostalCharges = 0;
  //             let SoftCopyFee = 0;
  //             let HardCopyFee = 0;
  //             let PerCopyDeliveryFee = 0;
  //             let totalHardCopyFee = 0;

  //             if (Delivery === 'Soft') {
  //                 SoftCopyFee = SoftCopy;
  //                 PostalCharges = SoftCopyFee;
  //                 TotalFee += SoftCopyFee;
  //             } else if (Delivery === 'Hard' && DeliveryAt === 'OFI') {
  //                 HardCopyFee = HardCopy;
  //                 PerCopyDeliveryFee = PerCopyDelivery;
  //                 totalHardCopyFee = HardCopyFee + PerCopyDeliveryFee;
  //                 PostalCharges = totalHardCopyFee;
  //                 TotalFee += PerCopyDeliveryFee;
  //             } else if (Delivery === 'Both' && DeliveryAt === 'OFI') {
  //                 SoftCopyFee = SoftCopy;
  //                 HardCopyFee = HardCopy;
  //                 PerCopyDeliveryFee = PerCopyDelivery;
  //                 totalHardCopyFee = HardCopyFee + PerCopyDeliveryFee;
  //                 PostalCharges = SoftCopyFee + totalHardCopyFee;
  //                 TotalFee += SoftCopyFee + PerCopyDeliveryFee;
  //             } else if (Delivery === 'Hard' && DeliveryAt === 'IN') {
  //                 HardCopyFee = HardCopy;
  //                 PerCopyDeliveryFee = 0;
  //                 totalHardCopyFee = HardCopyFee + PerCopyDeliveryFee;
  //                 PostalCharges = 0;
  //                 TotalFee += HardCopyFee;
  //             } else if (Delivery === 'Both' && DeliveryAt === 'IN') {
  //                 SoftCopyFee = SoftCopy;
  //                 HardCopyFee = HardCopy;
  //                 PerCopyDeliveryFee = 0;
  //                 totalHardCopyFee = HardCopyFee + PerCopyDeliveryFee;
  //                 PostalCharges = SoftCopyFee + totalHardCopyFee;
  //                 TotalFee += SoftCopyFee;
  //             }
  //             this.tableData = [
  //                 { head: 'Attestation Fee', headName: 'Base Fee (for 7 copies)', feeAmount: BaseAmount },
  //                 { head: `Additional Sets (${CertCopies > 7 ? CertCopies - 7 : 0} sets)`, headName: 'Additional Copies Fee', feeAmount: CopiesFee },
  //                 { head: 'Delivery Charges', headName: 'Postal Charges', feeAmount: PostalCharges }
  //             ];
  //             const creds = this.FeeForm.controls.feeHeadArray as FormArray;
  //             creds.clear();
  //             this.tableData.forEach((element) => {
  //                 creds.push(
  //                     this.fb.group({
  //                         FeeHead: new FormControl(element.head, [Validators.required]),
  //                         HeadName: new FormControl(element.headName),
  //                         FeePaid: new FormControl(0),
  //                         FeeDue: new FormControl(element.feeAmount),
  //                         FeeDueDummy: new FormControl(element.feeAmount),
  //                         FeeAmt: new FormControl(element.feeAmount, [Validators.required]),
  //                     })
  //                 );
  //             });

  //             this.TotalFee = TotalFee;
  //             this.spinner.hide();
  //         } else {
  //             this.spinner.hide();
  //         }
  //     });
  // }
  CalculateAttestationFee() {

    this.spinner.show();

    let payload: any = {};

    payload['StuId'] =
      this.StudentPersonalId != null
        ? this.StudentPersonalId
        : sessionStorage.getItem('StudentRGID');

    this.umsService.SearchTranscript(payload).subscribe(
      (res) => {

        if (res.status) {

          this.TranscriptData = res.data[0];
          this.Transcript = true;

          const BaseAmount = 3050;

          // Attestation Fee Per Copy
          const PerCopyFee = 800;

          // Soft Copy Delivery Fee
          const SoftCopyFeeAmount = 800;

          // Hard Copy Base Fee
          const HardCopyBaseFee = 2570;

          // Hard Copy Delivery Charges Per Copy
          const PerCopyDelivery = 800;
          const CertCopies =
            Number(res.data[0].StuCertCopies || 0);

          const Delivery =
            res.data[0].DeliveryOpt;

          this.TotalFee = 0;

          this.CopiesFee = 0;

          this.TranscriptFee = 0;

          this.SoftCopyFee = 0;

          this.HardCopyFee = 0;

          this.PerCopyDeliveryFee = 0;

          this.PostalCharges = 0;
          this.CopiesFee =
            PerCopyFee * CertCopies;

          this.TranscriptFee =
            BaseAmount + this.CopiesFee;
          if (Delivery === 'Soft') {

            this.SoftCopyFee =
              SoftCopyFeeAmount;

            this.PostalCharges =
              this.SoftCopyFee;

          }
          else if (Delivery === 'Hard') {

            this.HardCopyFee =
              HardCopyBaseFee;

            this.PerCopyDeliveryFee =
              PerCopyDelivery * CertCopies;

            this.PostalCharges =
              this.HardCopyFee +
              this.PerCopyDeliveryFee;

          }
          else if (Delivery === 'Both') {

            this.SoftCopyFee =
              SoftCopyFeeAmount;

            this.HardCopyFee =
              HardCopyBaseFee;

            this.PerCopyDeliveryFee =
              PerCopyDelivery * CertCopies;

            this.PostalCharges =
              this.SoftCopyFee +
              this.HardCopyFee +
              this.PerCopyDeliveryFee;

          }
          this.TotalFee =
            this.TranscriptFee +
            this.PostalCharges;

          const creds =
            this.FeeForm.controls
              .feeHeadArray as FormArray;

          while (creds.length > 0) {

            creds.removeAt(0);

          }
          this.tableData = [

            {
              head: 'Base Amount',
              headName: 'Base Transcript Fee',
              feeAmount: BaseAmount
            },

            {
              head: `Fee For Attestation (${CertCopies} Set)`,
              headName: 'Copies Fee',
              feeAmount: this.CopiesFee
            },

            {
              head: 'Postal Charges',
              headName: 'Total Delivery Charges',
              feeAmount: this.PostalCharges
            },

            {
              head: 'Hard Copy Base Fee',
              headName: 'Hard Copy Charges',
              feeAmount: this.HardCopyFee
            },

            {
              head: ' Extra Hard Copy Delivery Charges',
              headName: 'Per Copy Delivery',
              feeAmount: this.PerCopyDeliveryFee
            },

            {
              head: 'Soft Copy',
              headName: 'Soft Copy Amount',
              feeAmount: this.SoftCopyFee
            }

          ];
          this.tableData.forEach((element) => {

            creds.push(

              this.fb.group({

                FeeHead: new FormControl(
                  element.head,
                  [Validators.required]
                ),

                HeadName: new FormControl(
                  element.headName
                ),

                FeePaid: new FormControl(0),

                FeeDue: new FormControl(
                  element.feeAmount
                ),

                FeeDueDummy: new FormControl(
                  element.feeAmount
                ),

                FeeAmt: new FormControl(
                  element.feeAmount,
                  [Validators.required]
                ),

              })

            );

          });

          console.log('Transcript Fee => ', this.TranscriptFee);
          console.log('Total Fee => ', this.TotalFee);

          this.spinner.hide();

        }
        else {

          this.spinner.hide();

        }

      });

  }

  isSubhead(row: { head: string; headName: string }): boolean {
    const normalizedHead = this.normalizeHead(row.head);
    return [
      'Copies',
      'Hard Copy',
      'Soft Copy',
      'Base Amount'
    ].includes(row.headName) || [
      'Hard Copy',
      'Soft Copy',
      'Base Amount',
    ].includes(normalizedHead);
  }

  isHead(row: { head: string; headName: string }): boolean {
    const normalizedHead = this.normalizeHead(row.head);
    return [
      'Transcript Fee',
      'Postal Charges'
    ].includes(normalizedHead);
  }

  normalizeHead(head: string): string {
    // Normalize dynamic "(x Set)" names
    return head.replace(/\s*\(\d+\s*Set\)/, '');
  }


  openGatewayPopUp(item) {
    let data = {};
    data['item'] = item;
    data['PaidAmount'] = this.TotalFee;
    data['FeeType'] = this.data['CertType']
    data['StuId'] = this.StudentPersonalId;
    data['FeeTemplateCode'] = this.tempCo;
    data['SnNo'] = this.SnNo.toString();
    data['CgCode'] = this.item1.StuCollege;
    data['SelectedSubjectIds'] = this.SelectedSubjectIds;
    data['SelectedHeadIds'] = this.SelectedHeadIds;
    data['SelectedSubjectCount'] = this.SelectedSubjectCount;
    data['SelectedHeadCount'] = this.SelectedHeadCount;
    data['PayableHeadsCount'] = this.PayableHeadsCount;

    const dialogRef4 = this.dialog.open(PayGatewayComponent,
      {
        disableClose: true,
        width: "600px",
        height: "300px",
        data,
        panelClass: 'custom-dialog-container'
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }
}